export default "/list/static/images/HCom-2023.svg";